// Fotos (e PDFs) dos comprovantes: a foto é reduzida no próprio celular
// (lado maior de 1600 px, JPEG) para subir rápido com sinal fraco; o PDF vai
// como está. O sha256 prova depois que o arquivo não foi trocado.
import { sha256Js } from './assinatura.js';

export const LADO_MAXIMO = 1600;
export const TAMANHO_MAXIMO = 10 * 1024 * 1024; // o limite do bucket
const ACEITOS = ['image/jpeg', 'image/png', 'image/webp', 'image/heic', 'application/pdf'];

export async function sha256DoArquivo(blob) {
  const bytes = new Uint8Array(await blob.arrayBuffer());
  if (typeof crypto !== 'undefined' && crypto.subtle?.digest) {
    const hash = await crypto.subtle.digest('SHA-256', bytes);
    return [...new Uint8Array(hash)].map((x) => x.toString(16).padStart(2, '0')).join('');
  }
  return sha256Js(bytes);
}

async function reduzirImagem(arquivo) {
  const imagem = await createImageBitmap(arquivo, { imageOrientation: 'from-image' });
  const escala = Math.min(1, LADO_MAXIMO / Math.max(imagem.width, imagem.height));
  const tela = document.createElement('canvas');
  tela.width = Math.round(imagem.width * escala);
  tela.height = Math.round(imagem.height * escala);
  tela.getContext('2d').drawImage(imagem, 0, 0, tela.width, tela.height);
  imagem.close?.();
  const blob = await new Promise((ok) => tela.toBlob(ok, 'image/jpeg', 0.75));
  if (!blob) throw new Error('não deu para reduzir a foto');
  return blob;
}

// Arquivo escolhido → { blob, mime, tipo, bytes, sha256, nome }.
export async function prepararArquivo(arquivo) {
  const mime = arquivo.type || 'application/octet-stream';
  if (!ACEITOS.includes(mime)) {
    throw new Error('FORMATO: use foto (JPG, PNG, HEIC) ou PDF.');
  }
  let blob = arquivo;
  let tipoMime = mime;
  if (mime.startsWith('image/')) {
    try {
      blob = await reduzirImagem(arquivo);
      tipoMime = 'image/jpeg';
    } catch {
      // Sem como reduzir (formato que o navegador não abre): vai como está.
    }
  }
  if (blob.size > TAMANHO_MAXIMO) throw new Error('GRANDE_DEMAIS: o arquivo passa de 10 MB.');
  return {
    blob,
    mime: tipoMime,
    tipo: tipoMime === 'application/pdf' ? 'pdf' : 'foto',
    bytes: blob.size,
    sha256: await sha256DoArquivo(blob),
    nome: arquivo.name ?? '',
  };
}

export function extensao(mime) {
  return { 'image/jpeg': 'jpg', 'image/png': 'png', 'image/webp': 'webp', 'image/heic': 'heic', 'application/pdf': 'pdf' }[mime] ?? 'bin';
}
